import { Box, Divider } from '@material-ui/core';
import { AIProductMatchBadge, SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Product } from '@setvi/shared/interfaces';

export const AIProductMatch = ({
  percentage,
  reasoning
}: Pick<Product, 'percentage' | 'reasoning'>) => (
  <Box display="flex" flexDirection="column" mt={2}>
    <Divider style={{ marginBottom: 8 }} />
    <Box display="flex" alignItems="center" gridGap="4px" mb={2}>
      <AIProductMatchBadge fontSize={12} value={percentage} />
      <SText size="sm" weight="bold" title="Product Match" />
    </Box>
    <Box display="flex" alignItems="center">
      <SText
        size="xs"
        fontColor={TextColor.SlateGrey}
        noLineClamp
        title={reasoning}
      />
    </Box>
  </Box>
);
